module.exports = __webpack_public_path__ + "static/semantic-image-vertically-aligned-0297def766f3235b2da8d224a744efef.png";